import * as Yup from "yup";
import moment from "moment";
const defaultValuesMapping = {
  number: 0,
  file: null,
  image: null,
  files: [],
  images: [],
  boolean: true,
  string: "",
  date: moment().format("yyyy-MM-DD"),
};
// const config = {
//   fields: [
//     {
//       label: "",
//       key: "",
//       default: "",
//       type: "",
//       required: 0,
//       validation: { table: "", keySelector: "", labelSelector: "" },
//     },
//   ],
//   relations: {
//     key: [],
//   },
// };

export const getDefaultGenericForm = ({ fields }) =>
  fields.reduce(
    (prev, field) => {
      let val = field.default;
      if (!val && !field.relation) val = defaultValuesMapping[field.type]
      return Object.assign(prev, {
        [field.key]: val,
      })
    }
    ,
    {}
  );

export const generateGenericFormValidation = ({ fields, relations }) => {
  const shape = {};
  fields.forEach((field) => {
    if (field.skipValidation) return;
    let message = `${field.label} must be a valid ${field.type}.`;
    if (field.validation) shape[field.key] = field.validation;
    else if (field.relation) {
      let enums = (relations[field.relation.table].data || []).map(
        (row) => row[field.relation.keySelector]
      );
      // console.log({ enums });
      if (field.relation.multipe)
        shape[field.key] = field.required ? Yup.array()
          .of(Yup.mixed().oneOf(enums, message).required(message))
          .required(message) : Yup.array()
            .of(Yup.mixed().oneOf(enums, message).nullable(true))
            .nullable(true);
      else
        shape[field.key] = field.required ? Yup.mixed().oneOf(enums, message).required(message) : Yup.mixed().oneOf(enums, message).nullable(true);
      return;
    } else if (["file", "image"].includes(field.type))
      shape[field.key] = Yup.object()
        .nullable(true)
        .shape({
          name: field.required
            ? Yup.string().required(message)
            : Yup.string().nullable(true),
        });
    else if (["files", "images"].includes(field.type))
      shape[field.key] = Yup.array()
        .of(
          Yup.object()
            .nullable(true)
            .shape({
              name: field.required
                ? Yup.string().required(message)
                : Yup.string().nullable(true),
            })
        )
        .required(message);
    else if (field.required)
      shape[field.key] = Yup[field.type]().required(message);
    else shape[field.key] = Yup[field.type]();
  });
  // console.log(shape);
  return Yup.object().shape(shape);
};
